package com.cs.ejobin.web

import androidx.compose.runtime.*
import com.cs.ejobin.navigation.NavAction
import com.cs.ejobin.navigation.NavController
import com.cs.ejobin.navigation.WebRoutes
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun WebUrlSync(nav: NavController) {
    fun screenFromUrl() = WebRoutes.fromPath(
        pathname = window.location.pathname,
        query = parseQuery(window.location.search)
    )

    LaunchedEffect(Unit) {
        nav.setFromWeb(screenFromUrl())
    }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            nav.setFromWeb(screenFromUrl())
        }
        window.addEventListener("popstate", listener)
        onDispose { window.removeEventListener("popstate", listener) }
    }

    val current by nav.current.collectAsState()
    val action by nav.lastAction.collectAsState()

    LaunchedEffect(current, action) {
        val path = WebRoutes.toPath(current)

        when (action) {
            NavAction.Navigate -> {
                window.history.pushState(null, "", path)
            }
            NavAction.Reset,
            NavAction.External -> {
                window.history.replaceState(null, "", path)
            }
            NavAction.Pop -> {
                window.history.replaceState(null, "", path)
            }
        }
    }
}

/** Parse query string sans dépendre de URLSearchParams (bindings variables selon versions). */
private fun parseQuery(search: String): Map<String, String> {
    val raw = search.removePrefix("?").trim()
    if (raw.isEmpty()) return emptyMap()

    val out = mutableMapOf<String, String>()

    raw.split("&")
        .asSequence()
        .filter { it.isNotBlank() }
        .forEach { part ->
            val idx = part.indexOf('=')
            val key = if (idx >= 0) part.substring(0, idx) else part
            val value = if (idx >= 0) part.substring(idx + 1) else ""
            val k = js("decodeURIComponent")(key.replace("+", " ")) as String
            val v = js("decodeURIComponent")(value.replace("+", " ")) as String

            out[k] = v
        }

    return out
}